// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scroll-top{text-decoration:none!important;position:fixed;z-index:1000;bottom:20px;right:30px;border-radius:50%;background:hsla(0,0%,100%,.7);width:6vh;height:6vh;display:flex;justify-content:center;align-items:center;font-size:3vh;color:var(--color-logo2)!important;box-shadow:0 0 5px -1px var(--color-logo2)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
